(function () {
  var fileInput = document.getElementById('previewFileInput');
  var uploadZone = document.getElementById('previewUploadZone');
  var sliderBlock = document.getElementById('previewSlider');
  var imgBefore = document.getElementById('previewImgBefore');
  var imgAfter = document.getElementById('previewImgAfter');
  var frame = document.getElementById('previewSliderFrame');
  var beforeSide = document.getElementById('previewBefore');
  var handle = document.getElementById('previewHandle');
  var resetBtn = document.getElementById('previewResetBtn');
  var scrollBtn = document.getElementById('previewScrollBtn');
  var tool = document.getElementById('previewTool');

  if (!fileInput) return;

  scrollBtn.addEventListener('click', function () {
    tool.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Turns a photo into a pencil-sketch line drawing using canvas.
  // Technique: grayscale layer + inverted/blurred layer blended with "color-dodge".
  function makeSketch(img, callback) {
    var maxW = 900;
    var scale = Math.min(1, maxW / img.naturalWidth);
    var w = Math.round(img.naturalWidth * scale);
    var h = Math.round(img.naturalHeight * scale);

    var grayCanvas = document.createElement('canvas');
    grayCanvas.width = w;
    grayCanvas.height = h;
    var grayCtx = grayCanvas.getContext('2d');
    grayCtx.filter = 'grayscale(1) contrast(1.05)';
    grayCtx.drawImage(img, 0, 0, w, h);

    var blurCanvas = document.createElement('canvas');
    blurCanvas.width = w;
    blurCanvas.height = h;
    var blurCtx = blurCanvas.getContext('2d');
    blurCtx.filter = 'invert(1) blur(' + Math.max(3, Math.round(w / 180)) + 'px)';
    blurCtx.drawImage(grayCanvas, 0, 0);

    var outCanvas = document.createElement('canvas');
    outCanvas.width = w;
    outCanvas.height = h;
    var outCtx = outCanvas.getContext('2d');
    outCtx.fillStyle = '#ffffff';
    outCtx.fillRect(0, 0, w, h);
    outCtx.drawImage(grayCanvas, 0, 0);
    outCtx.globalCompositeOperation = 'color-dodge';
    outCtx.drawImage(blurCanvas, 0, 0);
    outCtx.globalCompositeOperation = 'source-over';

    callback(outCanvas.toDataURL('image/png'));
  }

  fileInput.addEventListener('change', function (e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;

    var reader = new FileReader();
    reader.onload = function (evt) {
      var dataUrl = evt.target.result;
      var img = new Image();
      img.onload = function () {
        imgAfter.src = dataUrl; // Light On: full-color, shiny photo
        makeSketch(img, function (sketchDataUrl) {
          imgBefore.src = sketchDataUrl; // Light Off: pencil-sketch look
        });

        uploadZone.hidden = true;
        sliderBlock.hidden = false;
        setClip(50);
      };
      img.src = dataUrl;
    };
    reader.readAsDataURL(file);
  });

  resetBtn.addEventListener('click', function () {
    fileInput.value = '';
    sliderBlock.hidden = true;
    uploadZone.hidden = false;
  });

  function setClip(percent) {
    percent = Math.max(0, Math.min(100, percent));
    beforeSide.style.clipPath = 'inset(0 ' + (100 - percent) + '% 0 0)';
    handle.style.left = percent + '%';
  }

  function percentFromEvent(clientX) {
    var rect = frame.getBoundingClientRect();
    var x = clientX - rect.left;
    return (x / rect.width) * 100;
  }

  var dragging = false;

  function startDrag(clientX) {
    dragging = true;
    setClip(percentFromEvent(clientX));
  }
  function moveDrag(clientX) {
    if (!dragging) return;
    setClip(percentFromEvent(clientX));
  }
  function endDrag() {
    dragging = false;
  }

  // Mouse events
  handle.addEventListener('mousedown', function (e) { startDrag(e.clientX); });
  frame.addEventListener('mousedown', function (e) { startDrag(e.clientX); });
  window.addEventListener('mousemove', function (e) { moveDrag(e.clientX); });
  window.addEventListener('mouseup', endDrag);

  // Touch events
  handle.addEventListener('touchstart', function (e) { startDrag(e.touches[0].clientX); }, { passive: true });
  frame.addEventListener('touchstart', function (e) { startDrag(e.touches[0].clientX); }, { passive: true });
  window.addEventListener('touchmove', function (e) {
    if (!dragging) return;
    moveDrag(e.touches[0].clientX);
  }, { passive: true });
  window.addEventListener('touchend', endDrag);
})();